// import Pages from 'layouts/Pages';
import Dashboard from 'layouts/Dashboard';

const indexRoutes = [{ path: '/', component: Dashboard }];

export default indexRoutes;

// WEBPACK FOOTER //
// ./src/routes/index
